// extracted by mini-css-extract-plugin
export default {"container":"JsonViewer_container__3fVoI","key":"JsonViewer_key__I6+xA","value":"JsonViewer_value__0YO3R"};